// src/ZeroIndegreePage.jsx
import ZeroIndegreeVisual from "./ZeroIndegreeVisual";
import {Typography} from "@mui/material";
import React from "react";

export default function ZeroIndegreePage() {
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-4">Zero In-Degree Algorithm</h1>
      <Typography variant="body1" paragraph>
        This interactive lets you run the zero in-degree algorithm. This interactive comes from
          Gemini3.
      </Typography>
      <ZeroIndegreeVisual />
    </div>
  );
}
